import { TranslateModule } from '@ngx-translate/core';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CirclePercentComponent } from './circle-percent.component';
import { NumberToTimePipeModule } from 'src/app/pipes/number-to-time.pipe';



@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NumberToTimePipeModule
  ],
  exports: [CirclePercentComponent],
  declarations: [CirclePercentComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CirclePercentComponentModule {}
